import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import DashboardContext from '#/context';
import useWidget from '#/hooks/useWidget';
import NotFound from '#/components/NotFound';
import Loader from '#/components/Loader';
import styles from './styles.module.css';
import { Colors, ObjectUtils } from '#/utils/utils';
import { useTranslation } from "react-i18next";
import FloatingTooltip from '#/components/FloatingTooltip/index';


function List({ dashboardWidgetId, endpoint, ordination, exhibition, widgetBindDtos, widgetId, auxiliaryOptionsDto }) {
  const { filters, localFilters, date, polling } = useContext(DashboardContext);
  const { serviceData } = useWidget(
    endpoint,
    filters,
    localFilters,
    date,
    polling,
    dashboardWidgetId,
    ordination,
    exhibition,
    widgetBindDtos, 
    auxiliaryOptionsDto
  );

  const { t } = useTranslation();


  const generateRandomColor = index => {
    const colors = Colors.randomColors(exhibition || 10);
    return colors[index];
  }

  const renderIcon = (title, imagePath, index) => {
    return imagePath ? (
      <img
        src={imagePath}
        alt={t('PROFILE_PHOTO')}
        draggable={false}
        className={styles.image}
      />
    ) : (
        <h2
          className={styles.initials}
          style={{ background: generateRandomColor(index) }}
        >
          {title && title.length > 1 ? `${title[0]}${title[1]}` : title && title.trim().length > 0 ? title[0] : ''}
        </h2>
      );
  };

  const getWidgetType = () => {
    const personWidgetsList = [7, 17, 20, 28, 38, 47];
    const workplaceWidgetsList = [21, 23, 27, 44, 48];

    if (personWidgetsList.find(id => id === +widgetId)) {
      return "person";
    }
    
    if (workplaceWidgetsList.find(id => id === +widgetId)) {
      return "workplace";
    }

    return;
  }

  const openOperationDesk = (id) => {
    const widgetType = getWidgetType();

    if (widgetType) {
      window.open(`${window.originHost}/#/operationdesk?${widgetType}Id=${id}`, "_blank");
    }
  }

  const renderBasicList = () => (
    <div className={styles.wrapper}>
      {serviceData.length ? (
        serviceData.map(
          (
            { id, title, description, imagePath, value, valueFormated },
            index
          ) => (
              <div className={styles.listItem} key={id}>
                <span className={styles.icon}>
                  {renderIcon(title, imagePath, index)}
                </span>
                <span className={styles.innerWrapper}>
                  <div className={styles.title}>
                    <FloatingTooltip content={title}>
                      <span className={`${getWidgetType(id) ? styles.operationDeskLink : null}`} onClick={() => openOperationDesk(id)}>
                        {ObjectUtils.abbreviationText(title)}
                      </span>
                    </FloatingTooltip>
                  </div>
                  <p className={styles.description}>{description}</p>
                </span>
                <p className={styles.number}>
                  {valueFormated ? valueFormated : value}
                </p>
              </div>
            )
        )
      ) : (
          <NotFound />
        )}
    </div>
  );
  return serviceData ? renderBasicList() : <Loader />;
}

List.propTypes = {
  endpoint: PropTypes.shape({
    endpointType: PropTypes.string,
    endpointUrl: PropTypes.string,
  }),
};

export default List;
